import * as React from 'react';
import { useSelector } from 'react-redux';

import { usePrevious } from '../../hooks/usePrevious';
import { getIsQuestionTab } from '../../selectors/tabs';
import { QuestionsListContainer } from '../QuestionsList';
import { ReviewsListContainer } from '../ReviewsList';

export function ItemsListContainer(): React.JSX.Element {
  const isQuestionTab = useSelector(getIsQuestionTab);
  const previousIsQuestionTab = usePrevious(isQuestionTab);

  if (isQuestionTab) {
    return <QuestionsListContainer />;
  }

  return <ReviewsListContainer isRevisited={Boolean(previousIsQuestionTab)} />;
}
